module.exports = __webpack_public_path__ + "static/media/(000093).77190811.jpg";